import { useState, useEffect } from "react";
import { FormikProps } from "formik";
import { CustomVideoForm } from "../Video";
import {
  filterAdminPresetsByTeamsAndType,
  filterPresetsByTeamsAndType,
} from "@/utils/mediautils/CommonFunctions";
import { AllAdminPresets, ProductModel } from "@/database";
import { PresetListModel } from "@/database";
import { convertChannelConfigToSocial } from "@/utils/mediautils/CommonFunctions";

interface UsePresetManagementProps {
  formik: FormikProps<CustomVideoForm>;
  presetList: PresetListModel[];
  singleCurrentUser: any;
  currentPresetDetails: any;
  bunchProductList: ProductModel[];
  getPresetList: (params: any) => void;
  getCurrentPresetDetails: (params: { id: string }) => void;
  getListProduct: (params: any) => void;
  getAdminPresetList: (params: any) => void;
  adminPresetList: AllAdminPresets;
  adminCurrentPresetDetails: any;
  getAdminCurrentPresetDetails: (params: any) => void;
}

interface UsePresetManagementReturn {
  presetProcessing: any[];
  presetMeta: any[];
  presetSocial: any[];
  presetBranding: any[];
  socialData: any;
  metaData: any;

  // adminPresetList: AllAdminPresets;
  processingData: any;
  brandingData: any;
  previewType: "social" | "meta" | "processing" | "branding" | null;
  setPreviewType: React.Dispatch<
    React.SetStateAction<"social" | "meta" | "processing" | "branding" | null>
  >;
}

export const usePresetManagement = ({
  formik,
  presetList,
  singleCurrentUser,
  currentPresetDetails,
  getPresetList,
  getCurrentPresetDetails,
  getListProduct,
  getAdminPresetList,
  bunchProductList,
  adminPresetList,
  adminCurrentPresetDetails,
  getAdminCurrentPresetDetails,
}: UsePresetManagementProps): UsePresetManagementReturn => {
  const [presetProcessing, setPresetProcessing] = useState<any>([]);
  const [presetMeta, setPresetMeta] = useState<any>([]);
  const [presetSocial, setPresetSocial] = useState<any>([]);
  const [presetBranding, setPresetBranding] = useState<any>([]);
  const [previewType, setPreviewType] = useState<
    null | "social" | "meta" | "processing" | "branding"
  >(null);
  const [socialData, setSocialData] = useState<any>([]);
  const [metaData, setMetaData] = useState<any>([]);
  const [processingData, setProcessingData] = useState<any>([]);
  const [brandingData, setBrandingData] = useState<any>([]);

  useEffect(() => {
    getAdminPresetList({
      keys: ["meta_preset", "publish_preset"],
      status: "active",
    });
  }, [getAdminPresetList]);

  // Fetch product list on mount
  useEffect(() => {
    getListProduct({});
  }, [getListProduct]);

  // Filter presets by type when presetList or singleCurrentUser changes

  useEffect(() => {
    if (
      adminPresetList?.meta_preset &&
      adminPresetList?.meta_preset?.length > 0
    ) {
      setPresetMeta(
        filterAdminPresetsByTeamsAndType(
          bunchProductList,
          adminPresetList,
          "meta_preset"
        )
      );
    }
  }, [adminPresetList, bunchProductList]);

  useEffect(() => {
    if (
      adminPresetList?.publish_preset &&
      adminPresetList?.publish_preset?.length > 0
    ) {
      setPresetSocial(
        filterAdminPresetsByTeamsAndType(
          bunchProductList,
          adminPresetList,
          "publish_preset"
        )
      );
    }
  }, [adminPresetList, bunchProductList]);

  // Update social data when publishing preset changes
  useEffect(() => {
    if (formik.values.publishing) {
      const data = presetSocial.find(
        (item: any) => item.id === formik.values.publishing
      );
      const convertedData = convertChannelConfigToSocial(data);
      setSocialData(convertedData);
    }
  }, [formik.values.publishing, presetSocial]);

  // Update meta data when meta preset changes
  useEffect(() => {
    if (formik.values.meta) {
      const data = presetMeta.find(
        (item: any) => item.id === formik.values.meta
      );
      setMetaData(data);
      // getCurrentPresetDetails({ id: formik.values.meta });
      getAdminCurrentPresetDetails({
        id: formik.values.meta,
        type: "meta_preset",
      });
    }
  }, [formik.values.meta, presetMeta, getCurrentPresetDetails]);

  // Update meta data when currentPresetDetails changes
  useEffect(() => {
    if (adminCurrentPresetDetails) {
      setMetaData(adminCurrentPresetDetails);
    }
  }, [adminCurrentPresetDetails]);

  // Update processing data when processing preset changes
  useEffect(() => {
    if (formik.values.processing) {
      const data = presetProcessing.find(
        (item: any) => item.id === formik.values.processing
      );
      setProcessingData(data);
    }
  }, [formik.values.processing, presetProcessing]);

  // Update branding data when branding preset changes
  useEffect(() => {
    if (formik.values.branding) {
      const data = presetBranding.find(
        (item: any) => item.id === formik.values.branding
      );
      setBrandingData(data);
    }
  }, [formik.values.branding, presetBranding]);

  return {
    presetProcessing,
    presetMeta,
    presetSocial,
    presetBranding,
    socialData,
    metaData,
    processingData,
    brandingData,
    previewType,
    setPreviewType,
  };
};
